import store from '../store';
import * as actions from "../actions";
import { getRotationDegrees } from './alignment';
import util from "../util";
import Renderer from "../canvas/renderer";
import Interactable from "./interactable";

export function convertFramePosToPx($target, $frameImg) {
    let originalX = 0;
    let originalY = 0;
    let borderWidth = $frameImg.attr('data-border-width') ? parseFloat($frameImg.attr('data-border-width')) : 0;
    let frameRatio = ($frameImg.width() - 2*borderWidth) / ($frameImg.height() - 2*borderWidth);
    let imgRatio = $target.width() / $target.height();

    if (frameRatio > imgRatio) {
        originalY = ($target.height() - ($frameImg.parent().height() - 2*borderWidth)) / -2;
    } else {
        originalX = ($target.width() - ($frameImg.parent().width() - 2*borderWidth)) / -2;
    }
    $frameImg.css('background-position-x', originalX + 'px');
    $frameImg.css('background-position-y', originalY + 'px');
    
    return [originalX, originalY];
}

export function deleteFramePreview() {
    $('.pages').find('[data-component="frame-preview"]').each(function() {
        const $this = $(this);
        Interactable.destroy(Interactable.of($this));
        $this.remove();
    });
    $('.pages').find('[page-component="frame-preview"]').each(function() {
        const $this = $(this);
        $this.remove();
    });
}

export function alignFramePreview($clone, $this) {
    const $frame = $this.find('.img');
    if ($frame.css('background-size') !== 'cover') {
        const pageWidth = util.getActiveDimensions().width;
        const pageHeight = util.getActiveDimensions().height;
        //const rotation = getRotationDegrees($this) * (Math.PI / 180);

        const dimensions = $frame.css('background-size').split(' ');
        const width = parseFloat(dimensions[0]);
        const height = parseFloat(dimensions[1]);
        $clone.css('width', `${width}px`);
        $clone.css('height', `${height}px`);

        let posX = parseFloat($this.css('left'));
        let posY = parseFloat($this.css('top'));
        let deltaX = parseFloat($frame.css('background-position-x'));
        let deltaY = parseFloat($frame.css('background-position-y'));

        const flippedX = $clone.find('img').attr('flipped-x');
        const flippedY = $clone.find('img').attr('flipped-y');
        const borderWidth = $frame.attr('data-border-width') ? parseFloat($frame.attr('data-border-width')) : 0;

        if (flippedX === 'true') {
            deltaX = parseFloat($frame.css('width')) - width - deltaX - borderWidth;
        } else {
            deltaX += borderWidth;
        }
        if (flippedY === 'true') {
            deltaY = parseFloat($frame.css('height')) - height - deltaY - borderWidth;
        } else {
            deltaY += borderWidth
        }

        $clone.css('transform-origin', `${$this.width()/2 - deltaX}px ${$this.height()/2 - deltaY}px`);
        posX += deltaX;
        posY += deltaY;
        posX = util.pixelToPercent(posX, pageWidth);
        posY = util.pixelToPercent(posY, pageHeight);

        $clone.css('left', posX + '%');
        $clone.css('top', posY + '%');
    }
}

export function startRepositionFrame(obj) {
    const $this = obj;
    if ($this.hasClass('locked')) return;
    if ($this.find('.img').css('background') && !$this.find('.img').css('background').includes('img-plc')) {
        let bgUrl = /(?:\(['"]?)(.*?)(?:['"]?\))/.exec($this.find('.img').css('background-image'))[1];
        let img = new Image;

        function loaded() {
            let bgImgWidth = img.width;
            let bgImgHeight = img.height;
            const aspectRatio = bgImgWidth / bgImgHeight;
            addClone(aspectRatio, true);
        }

        function addClone(aspectRatio, newFramePreview) {
            const originalBgCss = $this.find('.img').css('background');
            $this.attr('data-original-bg-css', originalBgCss);
            let rotation = getRotationDegrees($this);
            rotation = rotation * (Math.PI / 180);
            //if (rotation !== 0) return;
            
            const $clone = $this.clone();
            $clone.css('opacity',  '0.5');
            $clone.css('border-radius', '0%');

            let borderWidth = parseFloat($clone.find('.img').attr('data-border-width')) || 0;
            let transform = $clone.find('.img').css('transform') || "none";
            let flippedX = false;
            let flippedY = false;
            if (transform.includes("scale")) {
                const dataTransform = JSON.parse($this.attr('data-transform') || '{}');
                flippedY = dataTransform.verticalFlip || false;
                flippedX = dataTransform.horizontalFlip || false;
            } 
            let bgCssCancel = $this.find('.img').css('background');
            $clone.attr('data-bgcss-cancel', bgCssCancel);
            $clone.find('.img').remove();
            $clone.append(`<img src=${bgUrl} 
                        style="width: 100%; height: 100%; transform: ${transform};" 
                        data-border-width="${borderWidth}" 
                        flipped-x="${flippedX}" 
                        flipped-y="${flippedY}">`);

            if (newFramePreview) {
                const customRatio = (parseFloat($this.css('width'))) / (parseFloat($this.css('height')));
                const pageWidth = util.getActiveDimensions().width;
                const pageHeight = util.getActiveDimensions().height;
                const borderPercentX = util.pixelToPercent(borderWidth, pageWidth);
                const borderPercentY = util.pixelToPercent(borderWidth, pageHeight);
                if (aspectRatio > customRatio) { // wider than frame
                    let oldWidth = parseFloat($clone.css('width'));
                    if ($clone.css('width').indexOf('px') > -1) {
                        oldWidth = util.pixelToPercent(oldWidth, pageWidth);
                    }
                    let heightPx = parseFloat($this.css('height')) - 2*borderWidth;
                    let widthPx = heightPx * aspectRatio;
                    let heightPercent = util.pixelToPercent(heightPx, pageHeight);
                    let widthPercent = util.pixelToPercent(widthPx, pageWidth);
                    $clone.css('height', heightPercent + '%');
                    $clone.css('width', widthPercent + '%');
                    const cloneLeft = $clone.css('left') === 'auto' ? 0 : parseFloat($clone.css('left'));
                    const cloneTop = $clone.css('top') === 'auto' ? 0 : parseFloat($clone.css('top'));
                    let newLeft = cloneLeft - (widthPercent - oldWidth)/2;
                    let newTop = cloneTop + borderPercentY;
                    $clone.css('left', newLeft + '%');
                    $clone.css('top', newTop + '%');
                } else { // taller or equal
                    let oldHeight = parseFloat($clone.css('height'));
                    if ($clone.css('height').indexOf('px') > -1) {
                        oldHeight = util.pixelToPercent(oldHeight, pageHeight);
                    }

                    let widthPx = parseFloat($this.css('width')) - 2*borderWidth;
                    let heightPx = widthPx / aspectRatio;
                    let widthPercent = util.pixelToPercent(widthPx, pageWidth);
                    let heightPercent = util.pixelToPercent(heightPx, pageHeight);
                    $clone.css('width', widthPercent + '%');
                    $clone.css('height', heightPercent + '%');
                    const cloneLeft = $clone.css('left') === 'auto' ? 0 : parseFloat($clone.css('left'));
                    const cloneTop = $clone.css('top') === 'auto' ? 0 : parseFloat($clone.css('top'));
                    let newTop = cloneTop - (heightPercent - oldHeight)/2;
                    let newLeft = cloneLeft + borderPercentX;
                    $clone.css('top', newTop + '%');
                    $clone.css('left', newLeft + '%');
                }
            } else {
                alignFramePreview($clone, $this);
            }

            $clone.attr('data-ratio', '');
            $clone.attr('data-custom-ratio', aspectRatio);
            $clone.attr('data-component', 'frame-preview');
            $this.parent().append($clone);

            Renderer.deselectAll();
            store.dispatch(actions.deselect());
            Renderer.select($clone);
            store.dispatch(actions.select($clone));
            store.dispatch(actions.setSelectionType('frame-preview'));
        }

        if ($this.find('.img').css('background-position-x') === '50%') {
            img.src = bgUrl;
            img.onload = loaded;
        } else {
            let dimensions = $this.find('.img').css('background-size').split(' ');
            addClone(parseFloat(dimensions[0]) / parseFloat(dimensions[1], false));
        }
    }
}

export function adjustAfterFrameResize(edges, $target, width, height, ratio, isSideResize, ogWidth = 0, ogHeight = 0) {
    let $frameImg = $target.find('.img');
    if (!$frameImg.length) {
        $frameImg = $target.find('.video');
    }
    if ($frameImg.css('background-position-x') !== '50%') {
        const dimensions = $frameImg.css('background-size').split(' ');
        const borderWidth = parseFloat($frameImg.attr('data-border-width')) || 0;
        width -= 2*borderWidth;
        height -= 2*borderWidth;
        let bgWidth = parseFloat(dimensions[0]);
        let bgHeight = parseFloat(dimensions[1]);
        const bgRatio = bgWidth / bgHeight;
        ogWidth = ogWidth !== 0 ? ogWidth : parseFloat($target.css('width'));
        let widthRatio = bgWidth / ogWidth;
        if (widthRatio < 1) widthRatio = 1;
        ogHeight = ogHeight !== 0 ? ogHeight : parseFloat($target.css('height'));
        let heightRatio = bgHeight / ogHeight;
        if (heightRatio < 1) heightRatio = 1;
        let positionX = parseFloat($frameImg.css('background-position-x'));
        let positionY = parseFloat($frameImg.css('background-position-y'));
        const positionXRatio = positionX / bgWidth;
        const positionYRatio = positionY / bgHeight;

        function adjustHeight() {
            bgHeight =  heightRatio * height;
            bgWidth = bgHeight * bgRatio;
        }

        function adjustWidth() {
            bgWidth =  widthRatio * width;
            bgHeight = bgWidth / bgRatio;
        }

        if (!(ratio > -1 && !isSideResize)) {
            if (edges.top) {
                positionY -= (ogHeight - height);
                if (positionY > 0) {
                    adjustHeight()
                    positionY = 0;
                }
            }
            if (edges.bottom && bgHeight + positionY < height) {
                adjustHeight();
            }
            if (edges.left) {
                positionX -= (ogWidth - width);
                if (positionX > 0) {
                    adjustWidth();
                    positionX = 0;
                }
            }
            if (edges.right && bgWidth + positionX < width) {
                adjustWidth();
            }
        } else {
            if (widthRatio < heightRatio) {
                adjustWidth();
            } else {
                adjustHeight();
            }
            positionX = bgWidth * positionXRatio;
            positionY = bgHeight * positionYRatio;
        }

        $frameImg.css('background-size', `${bgWidth}px ${bgHeight}px`);
        $frameImg.css('background-position-x', `${positionX}px`);
        $frameImg.css('background-position-y', `${positionY}px`);
    }
}

export function adjustAfterBorderChange($target, diff) {
    if (diff !== 0) {
        const $frameImg = $target.find('.img');
        const dimensions = $frameImg.css('background-size').split(' ');
        let bgWidth = parseFloat(dimensions[0]);
        let bgHeight = parseFloat(dimensions[1]);
        const bgRatio = bgWidth / bgHeight;

        if (bgWidth < bgHeight) {
            bgWidth =  bgWidth + 2*diff;
            bgHeight = bgWidth / bgRatio;
        } else {
            bgHeight =  bgHeight + 2*diff;
            bgWidth = bgHeight * bgRatio;
        }
        $frameImg.css('background-size', `${bgWidth}px ${bgHeight}px`);
    }
}

export function adjustAfterPageResize($target) {
    const $frameImg = $target.find('.img');

    if ($frameImg.css('background-position-x') !== '50%') {
        const dimensions = $frameImg.css('background-size').split(' ');
        let bgWidth = parseFloat(dimensions[0]);
        let bgHeight = parseFloat(dimensions[1]);
        const bgRatio = bgWidth / bgHeight;
        
        const borderWidth = parseFloat($frameImg.attr('data-border-width')) || 0;
        let frameWidth = parseFloat($target.width()) - 2*borderWidth;
        let frameHeight = parseFloat($target.height()) - 2*borderWidth;
        const frameRatio = frameWidth / frameHeight;

        let widthRatio = bgWidth / frameWidth;
        let heightRatio = bgHeight / frameHeight;

        function setWidth() {
            bgWidth = frameWidth;
            bgHeight = bgWidth / bgRatio;
        }

        function setHeight() {
            bgHeight = frameHeight;
            bgWidth = bgHeight * bgRatio;
        }

        if (widthRatio < 1 && heightRatio < 1) {
            if (bgRatio > frameRatio) {
                //set height first
                setHeight();
            } else {
                // set width first
                setWidth();
            }
        } else if (widthRatio < 1) {
            setWidth();
        } else if (heightRatio < 1) {
            setHeight();
        }

        $frameImg.css('background-size', `${bgWidth}px ${bgHeight}px`);

        let positionX = parseFloat($frameImg.css('background-position-x'));
        let positionY = parseFloat($frameImg.css('background-position-y'));
        let isTilingRight = positionX + bgWidth < frameWidth;
        let isTilingBot = positionY + bgHeight < frameHeight;
        if (isTilingRight) positionX = $target.width() - bgWidth;
        if (isTilingBot) positionY = $target.height() - bgHeight;

        $frameImg.css('background-position-x', `${positionX}px`);
        $frameImg.css('background-position-y', `${positionY}px`);
    }
}
